import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/** KTE cart drawer: iOS-safe modal scroll locking and native Shopify cart events. */
class CartDrawerComponent extends DialogComponent {
  #locked = false;
  #scrollPosition = 0;
  #savedBodyStyle = null;
  #savedRootOverflow = '';
  #savedRootOverscroll = '';

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.addEventListener('dialog:open', this.#onOpen);
    this.addEventListener('dialog:close', this.#onClose);
    window.addEventListener('resize', this.#setFullHeight);
  }

  disconnectedCallback() {
    this.#restorePage();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener('dialog:open', this.#onOpen);
    this.removeEventListener('dialog:close', this.#onClose);
    window.removeEventListener('resize', this.#setFullHeight);
    super.disconnectedCallback();
  }

  #onOpen = () => {
    this.#lockPage();
    this.#setFullHeight();
  };

  #onClose = () => {
    this.#restorePage();
  };

  #lockPage = () => {
    if (this.#locked) return;
    this.#locked = true;
    this.#scrollPosition = window.scrollY || window.pageYOffset || 0;
    this.#savedBodyStyle = document.body.getAttribute('style');
    this.#savedRootOverflow = document.documentElement.style.overflow;
    this.#savedRootOverscroll = document.documentElement.style.overscrollBehavior;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.overscrollBehavior = 'none';
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + this.#scrollPosition + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  };

  #restorePage = () => {
    if (!this.#locked) return;
    this.#locked = false;
    if (this.#savedBodyStyle === null) {
      document.body.removeAttribute('style');
    } else {
      document.body.setAttribute('style', this.#savedBodyStyle);
    }
    document.documentElement.style.overflow = this.#savedRootOverflow;
    document.documentElement.style.overscrollBehavior = this.#savedRootOverscroll;
    window.scrollTo(0, this.#scrollPosition);
  };

  #handleCartAdd = (event) => {
    if (event.detail && event.detail.didError) return;
    if (this.hasAttribute('auto-open')) this.showDialog();
  };

  #setFullHeight = () => {
    if (!this.refs || !this.refs.dialog || !this.refs.dialog.open) return;
    const dialog = this.refs.dialog;
    const inner = dialog.querySelector('.cart-drawer__inner');
    if (!inner) return;
    const height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    dialog.style.height = height + 'px';
    inner.style.height = '100%';
  };

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
